import {create} from 'zustand';

const useBlogStore = create((set) => ({
  visibleCards: 12,
  setVisibleCards: (count) => set({ visibleCards: count }),
  incrementVisibleCards: () => set((state) => ({ 
    visibleCards: state.visibleCards + 6 
  })),
  resetVisibleCards: () => set({ visibleCards: 6 }),
}));

export default useBlogStore;